const UserRights = {

    CREATE_CLIENT:'CREATE_CLIENT',
    READ_CLIENT:'READ_CLIENT',
    UPDATE_CLIENT:'UPDATE_CLIENT',
    DELETE_CLIENT:'DELETE_CLIENT',

    CREATE_BULK_SMS:'CREATE_BULK_SMS',
    READ_BULK_SMS:'READ_BULK_SMS',
    UPDATE_BULK_SMS:'UPDATE_BULK_SMS',
    DELETE_BULK_SMS:'DELETE_BULK_SMS',

    CREATE_CLIENTMENU:'CREATE_CLIENTMENU',
    READ_CLIENTMENU:'READ_CLIENTMENU',
    UPDATE_CLIENTMENU:'UPDATE_CLIENTMENU',
    DELETE_CLIENTMENU:'DELETE_CLIENTMENU',

    CREATE_CLIENT_MNO:'CREATE_CLIENT_MNO',
    READ_CLIENT_MNO:'READ_CLIENT_MNO',
    UPDATE_CLIENT_MNO:'UPDATE_CLIENT_MNO',
    DELETE_CLIENT_MNO:'DELETE_CLIENT_MNO',

    CREATE_REVENUECODE:'CREATE_REVENUECODE',
    READ_REVENUECODE:'READ_REVENUECODE',
    UPDATE_REVENUECODE:'UPDATE_REVENUECODE',
    DELETE_REVENUECODE:'DELETE_REVENUECODE',

    CREATE_REVENUEPOINT:'CREATE_REVENUEPOINT',
    READ_REVENUEPOINT:'READ_REVENUEPOINT',
    UPDATE_REVENUEPOINT:'UPDATE_REVENUEPOINT',
    DELETE_REVENUEPOINT:'DELETE_REVENUEPOINT',

    CREATE_MNO:'CREATE_MNO',
    READ_MNO:'READ_MNO',
    UPDATE_MNO:'UPDATE_MNO',
    DELETE_MNO:'DELETE_MNO',

    CREATE_PAYMENTS_PROVIDER:'CREATE_PAYMENTS_PROVIDER',
    READ_PAYMENTS_PROVIDER:'READ_PAYMENTS_PROVIDER',
    UPDATE_PAYMENTS_PROVIDER:'UPDATE_PAYMENTS_PROVIDER',
    DELETE_PAYMENTS_PROVIDER:'DELETE_PAYMENTS_PROVIDER',


    CREATE_SESSION:'CREATE_SESSION',
    READ_SESSION:'READ_SESSION',
    UPDATE_SESSION:'UPDATE_SESSION',
    DELETE_SESSION:'DELETE_SESSION',








    CREATE_USER:'CREATE_USER',
    READ_USER:'READ_USER',
    UPDATE_USER:'UPDATE_USER',
    DELETE_USER:'DELETE_USER',

    CREATE_USER_GROUP:'CREATE_USER_GROUP',
    READ_USER_GROUP:'READ_USER_GROUP',
    UPDATE_USER_GROUP:'UPDATE_USER_GROUP',
    DELETE_USER_GROUP:'DELETE_USER_GROUP',

    CREATE_RIGHT:'CREATE_RIGHT',
    READ_RIGHT:'READ_RIGHT',
    UPDATE_RIGHT:'UPDATE_RIGHT',
    DELETE_RIGHT:'DELETE_RIGHT',





    CREATE_GROUP_RIGHT:'CREATE_GROUP_RIGHT',
    READ_GROUP_RIGHT:'READ_GROUP_RIGHT',
    UPDATE_GROUP_RIGHT:'UPDATE_GROUP_RIGHT',
    DELETE_GROUP_RIGHT:'DELETE_GROUP_RIGHT',

    CREATE_GROUP:'CREATE_GROUP',
    READ_GROUP:'READ_GROUP',
    UPDATE_GROUP:'UPDATE_GROUP',
    DELETE_GROUP:'DELETE_GROUP',

    CREATE_SMS:'CREATE_SMS',
    READ_SMS:'READ_SMS',
    UPDATE_SMS:'UPDATE_SMS',
    DELETE_SMS:'DELETE_SMS',



    CREATE_TOPUP:'CREATE_TOPUP',
    READ_TOPUP:'READ_TOPUP',
    UPDATE_TOPUP:'UPDATE_TOPUP',
    DELETE_TOPUP:'DELETE_TOPUP',

    CREATE_SERVICE_TYPE:'CREATE_SERVICE_TYPE',
    READ_SERVICE_TYPE:'READ_SERVICE_TYPE',
    UPDATE_SERVICE_TYPE:'UPDATE_SERVICE_TYPE',
    DELETE_SERVICE_TYPE:'DELETE_SERVICE_TYPE',

    CREATE_SURVEY:'CREATE_SURVEY',
    READ_SURVEY:'READ_SURVEY',
    UPDATE_SURVEY:'UPDATE_SURVEY',
    DELETE_SURVEY:'DELETE_SURVEY',

    CREATE_OTHER_PAYMENT_TYPE:'CREATE_OTHER_PAYMENT_TYPE',
    READ_OTHER_PAYMENT_TYPE:'READ_OTHER_PAYMENT_TYPE',
    UPDATE_OTHER_PAYMENT_TYPE:'UPDATE_OTHER_PAYMENT_TYPE',
    DELETE_OTHER_PAYMENT_TYPE:'DELETE_OTHER_PAYMENT_TYPE',

    CREATE_CUSTOMER_FIELD:'CREATE_CUSTOMER_FIELD',
    READ_CUSTOMER_FIELD:'READ_CUSTOMER_FIELD',
    UPDATE_CUSTOMER_FIELD:'UPDATE_CUSTOMER_FIELD',
    DELETE_CUSTOMER_FIELD:'DELETE_CUSTOMER_FIELD',

    CREATE_COMPLAINT_TYPE:'CREATE_COMPLAINT_TYPE',
    READ_COMPLAINT_TYPE:'READ_COMPLAINT_TYPE',
    UPDATE_COMPLAINT_TYPE:'UPDATE_COMPLAINT_TYPE',
    DELETE_COMPLAINT_TYPE:'DELETE_COMPLAINT_TYPE',

    CREATE_SERVICE_APPLICATION:'CREATE_SERVICE_APPLICATION',
    READ_SERVICE_APPLICATION:'READ_SERVICE_APPLICATION',
    UPDATE_SERVICE_APPLICATION:'UPDATE_SERVICE_APPLICATION',
    DELETE_SERVICE_APPLICATION:'DELETE_SERVICE_APPLICATION',

    CREATE_CUSTOMER_FIELD_UPDATE:'CREATE_CUSTOMER_FIELD_UPDATE',
    READ_CUSTOMER_FIELD_UPDATE:'READ_CUSTOMER_FIELD_UPDATE',
    UPDATE_CUSTOMER_FIELD_UPDATE:'UPDATE_CUSTOMER_FIELD_UPDATE',
    DELETE_CUSTOMER_FIELD_UPDATE:'DELETE_CUSTOMER_FIELD_UPDATE',

    CREATE_COMPLAINT:'CREATE_COMPLAINT',
    READ_COMPLAINT:'READ_COMPLAINT',
    UPDATE_COMPLAINT:'UPDATE_COMPLAINT',
    DELETE_COMPLAINT:'DELETE_COMPLAINT',

    CREATE_PAYMENT:'CREATE_PAYMENT',
    READ_PAYMENT:'READ_PAYMENT',
    UPDATE_PAYMENT:'UPDATE_PAYMENT',
    DELETE_PAYMENT:'DELETE_PAYMENT',

    READ_COMPLAINTTYPEMENU:'READ_COMPLAINTTYPEMENU',
    READ_COMPLAINTSDASHBOARD:'READ_COMPLAINTSDASHBOARD',
    READ_RIGHTMENU:'READ_RIGHTMENU',

    MENU_SUMMARYDASHBOARD:'MENU_SUMMARYDASHBOARD',
    MENU_MAINDASHBOARD:'MENU_MAINDASHBOARD',
    MENU_DAYDASHBOARD:'MENU_DAYDASHBOARD',
    MENU_USERDASHBOARD:'MENU_USERDASHBOARD',
    MENU_PAYMENTS:'MENU_PAYMENTS',
    MENU_NOTRECEIPTED:'MENU_NOTRECEIPTED', 
    MENU_REVIEWTRANSACTION:'MENU_REVIEWTRANSACTION',
    MENU_REVIEWCLIENTTRANSACTION:'MENU_REVIEWCLIENTTRANSACTION',
    MENU_REVIEWUSSDSESSION:'MENU_REVIEWUSSDSESSION',
    MENU_FAILEDTRANSACTIONS:'MENU_FAILEDTRANSACTIONS',
    MENU_TENANTS:'MENU_TENANTS',
    MENU_PAYMENTPROVIDERS:'MENU_PAYMENTPROVIDERS',
    MENU_REVENUEPOINTS:'MENU_REVENUEPOINTS',
    MENU_MNOS:'MENU_MNOS',
    MENU_COMPLAINTSDASHBOARD:'MENU_COMPLAINTSDASHBOARD',
    MENU_COMPLAINTCODES:'MENU_COMPLAINTCODES',
    MENU_TEXTMESSAGING:'MENU_TEXTMESSAGING',
    MENU_SURVEYS:'MENU_SURVEYS',
    MENU_USERS:'MENU_USERS',
    MENU_ACCESSCONTROL:'MENU_ACCESSCONTROL',
    MENU_SETTINGS:'MENU_SETTINGS',

    REPORT_REVENUECOLLECTOR:'REPORT_REVENUECOLLECTOR',
    REPORT_CONSUMERTIER:'REPORT_CONSUMERTIER',
    REPORT_CONSUMERTYPE:'REPORT_CONSUMERTYPE',

    CREATE_SETTING:'CREATE_SETTING',
    READ_SETTING:'READ_SETTING',
    UPDATE_SETTING:'UPDATE_SETTING',
    DELETE_SETTING:'DELETE_SETTING',

    MENU_PROMOTIONS:'MENU_PROMOTIONS',
    CREATE_PROMOTION:'CREATE_PROMOTION',
    READ_PROMOTION:'READ_PROMOTION',
    UPDATE_PROMOTION:'UPDATE_PROMOTION',
    DELETE_PROMOTION:'DELETE_PROMOTION'
    
}

export default UserRights
